module.exports = __webpack_public_path__ + "static/media/DOUGLAS SHIRE.5ae3d6df.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/council_areas/DOUGLAS SHIRE.svg
// module id = 541
// module chunks = 0